module.exports = __webpack_public_path__ + "img/smb-key-keeper-old-pink.256.56ff3be1.png";